<template>
  <div id="app">
    <router-view />
    <b-loading
      :is-full-page="true"
      :active.sync="is_loading"
      :can-cancel="true"
    ></b-loading>
    <createmodal></createmodal>
    <KeyValueTableModal />
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import APIService from "@/services/api.service";
import createmodal from "./components/sidebar/components/menu/components/features-type/modal/modal.compoent";
const apiService = new APIService();
import KeyValueTableModal from "./components/num-table-modal";
import * as FullStory from "@fullstory/browser";
import jwt_decode from "jwt-decode";

export default {
  data() {
    return {
      is_session_expired: true,
    };
  },
  components: {
    createmodal,
    KeyValueTableModal,
  },
  async created() {
    this.update_feature_props_from_parent();
    // this.$root.$on("token_expired", () => {
    //   parent.postMessage("token_expired", "*");
    //   this.is_session_expired = false;
    // });
    await this.initialize();
    // if (!this.lang_data) await this.get_lang();
    // this.$store.commit("SET_STRATEGIX4_TOKEN");
  },
  computed: {
    ...mapState(["token", "claims", "is_loading", "draw", "lang_data"]),
  },
  watch: {
    // Everytime the route changes, check for auth status
    $route: "isAuthenticated",
  },
  methods: {
    ...mapMutations([
      "SET_AUTHENTICATED",
      "SET_TOKEN",
      "SET_CLAIMS",
      "UPDATE_ACTIVE_PROJECTS",
      "SET_CONTAINER",
      "LOAD_SOURCES",
      "SET_ROUTE_NAME",
      "SET_SPLIT_CLIENT",
      "SET_LANG_DATA",
    ]),
    isAuthenticated() {
      if (!window.$cookies.get("access_token")) {
        this.is_session_expired = false;
      }
    },
    initialize_split() {
      // Instantiate the SDK. CDN will expose splitio globally
      let decodedJwt = jwt_decode(window.$cookies.get("access_token"));
      var factory = splitio({
        core: {
          authorizationKey: process.env.VUE_APP_SPLIT_KEY,
          // your internal user id, or the account id that
          // the user belongs to.
          // This coudld also be a cookie you generate
          // for anonymous users
          key: decodedJwt.sub || decodedJwt.email || this.claims.email,
          // an OPTIONAL traffic type, if provided will be
          // used for event tracking with the SDK client.
          trafficType: "A_TRAFFIC_TYPE",
        },
      });
      // And get the client instance you'll use
      var client = factory.client();
      client.on(client.Event.SDK_READY, () => {
        this.SET_SPLIT_CLIENT(client);
        this.init_fullstory();
      });
    },
    init_fullstory() {
      if (!this.$store.getters.enable_fullstory) return;

      FullStory.init({ orgId: "TSJVD", recordCrossDomainIFrames: true });
      FullStory.identify(this.$store.state.claims.user_id, {
        displayName:
          this.$store.state.claims.firstname +
          " " +
          this.$store.state.claims.lastname,
        ...this.$store.state.claims,
      });
    },
    async get_lang() {
      try {
        let lang =
          localStorage.getItem("language") ||
          (navigator && navigator.language
            ? navigator.language.split("-")[0]
            : "en");
        let res = await apiService.get_lang({
          lang,
        });
        this.SET_LANG_DATA(res.data);
      } catch (err) {
        if (err) {
          let res = await apiService.get_lang({});
          this.SET_LANG_DATA(res.data);
        }
      }
    },
    async initialize() {
      if (!window.$cookies.get("access_token")) {
        this.is_session_expired = false;
      } else {
        this.SET_TOKEN(window.$cookies.get("access_token"));
        try {
          let res = await apiService.get_claims();
          if (res && res.data) {
            this.SET_CLAIMS(res.data);
            this.initialize_split();
            // if (!this.lang_data) await this.get_lang();
            // this.SET_ROUTE_NAME(this.$route.name);
            apiService
              .get_container({ id: this.$route.params.uid })
              .then((res) => {
                if (res && res.data) {
                  res.data.groups.forEach((element) => {
                    element.projects = element.projects.filter(
                      (p) => !p.properties || !p.properties.is_disabled
                    );
                  });
                }
                this.SET_CONTAINER(res.data);
              })
              .catch((err) => {
                this.handleErrors(err);
                console.log("Error :: while fetching container details.");
              });
          } else this.is_session_expired = false;
        } catch (err) {
          this.handleErrors(err);
          console.log(err);
          this.is_session_expired = false;
        }
      }
    },
    async update_features(data) {
      try {
        // let featureService = new FeatureService();
        // TODO to update the features
        let map_active_projects = Object.values(
          this.$store.state.active_projects
        ).filter((project) => project.is_feature_active);

        data = _.keyBy(data || [], (f) => f.properties.uid);

        for (let i = 0; i < map_active_projects.length; i++) {
          let project = map_active_projects[i];
          // let res = await featureService.get_project_features({
          //   uid: project.info.uid,
          //   query: "issue=true",
          // });

          this.UPDATE_ACTIVE_PROJECTS({
            payload: {
              ...this.$store.state.active_projects[project.uid],
              features: (project.features || []).map((f) => ({
                ...f,
                ...(data[f.properties.uid] || {}),
              })),
            },
            layer: project,
          });
        }

        this.draw.getAll().features.forEach((f) => {
          let feature = data[f.properties.uid];
          if (feature) {
            this.draw.setFeatureProperty(
              f.id,
              "element",
              feature.properties.element
            );
          }
        });
      } catch (err) {
        console.log("update_features", err);
      }
    },
    update_feature_props_from_parent() {
      let action = (data) => {
        if (
          data.name === "tickets-bulk-create-completed" ||
          data.name === "forms-bulk-create-completed"
        ) {
          this.update_features(data.data);
        } else if (
          data.name === "single-ticket-create-completed" ||
          data.name === "create-project-ticket-completed"
        ) {
          this.$root.$emit(data.name);
        } else if (data.name === "update_feature_props") {
          this.draw.setFeatureProperty(
            data.feature.id,
            "element",
            data.element
          );
        } else if (data.name === "lang_data") {
          this.SET_LANG_DATA(data.data);
        }
      };
      if (window.addEventListener) {
        window.addEventListener("message", (e) => action(e.data), false);
      } else if (window.attachEvent) {
        window.attachEvent("onmessage", (e) => action(e.data));
      }
    },
  },
};
</script>
<style lang="scss">
@import "assets/style/helper.css";
@import "~bulma-slider/dist/css/bulma-slider.min.css";
@import "~bulma-checkradio/dist/css/bulma-checkradio.min.css";

@font-face {
  font-family: "Barlow-Black";
  src: url(./assets/fonts/Barlow-Black.ttf);
}
@font-face {
  font-family: "Barlow-BlackItalic";
  src: url(./assets/fonts/Barlow-BlackItalic.ttf);
}
@font-face {
  font-family: "Barlow-Bold";
  src: url(./assets/fonts/Barlow-Bold.ttf);
}
@font-face {
  font-family: "Barlow-BoldItalic";
  src: url(./assets/fonts/Barlow-BoldItalic.ttf);
}
@font-face {
  font-family: "Barlow-ExtraBold";
  src: url(./assets/fonts/Barlow-ExtraBold.ttf);
}
@font-face {
  font-family: "Barlow-ExtraBoldItalic";
  src: url(./assets/fonts/Barlow-ExtraBoldItalic.ttf);
}
@font-face {
  font-family: "Barlow-ExtraLight";
  src: url(./assets/fonts/Barlow-ExtraLight.ttf);
}
@font-face {
  font-family: "Barlow-ExtraLightItalic";
  src: url(./assets/fonts/Barlow-ExtraLightItalic.ttf);
}
@font-face {
  font-family: "Barlow-Italic";
  src: url(./assets/fonts/Barlow-Italic.ttf);
}
@font-face {
  font-family: "Barlow-Light";
  src: url(./assets/fonts/Barlow-Light.ttf);
}
@font-face {
  font-family: "Barlow-LightItalic";
  src: url(./assets/fonts/Barlow-LightItalic.ttf);
}
@font-face {
  font-family: "Barlow-Medium";
  src: url(./assets/fonts/Barlow-Medium.ttf);
}
@font-face {
  font-family: "Barlow-MediumItalic";
  src: url(./assets/fonts/Barlow-MediumItalic.ttf);
}
@font-face {
  font-family: "Barlow";
  src: url(./assets/fonts/Barlow-Regular.ttf);
}
@font-face {
  font-family: "Barlow-Regular";
  src: url(./assets/fonts/Barlow-Regular.ttf);
}
@font-face {
  font-family: "Barlow-SemiBold";
  src: url(./assets/fonts/Barlow-SemiBold.ttf);
}
@font-face {
  font-family: "Barlow-SemiBoldItalic";
  src: url(./assets/fonts/Barlow-SemiBoldItalic.ttf);
}
@font-face {
  font-family: "Barlow-Thin";
  src: url(./assets/fonts/Barlow-Thin.ttf);
}
@font-face {
  font-family: "Barlow-ThinItalic";
  src: url(./assets/fonts/Barlow-ThinItalic.ttf);
}
.is-semiBold-16-600-19 {
  font-family: Barlow-SemiBold !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 19px !important;
}
.is-medium-16-500-19 {
  font-family: Barlow-Medium;
  font-size: 16px;
  font-weight: 500;
  line-height: 19px;
  color: #171e48;
}
.is-semibold-12-500-14 {
  font-family: Barlow-Medium;
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
}
.is-semibold-16-600-19 {
  font-family: Barlow-SemiBold;
  font-size: 16px;
  font-weight: 600;
  line-height: 19px;
  color: #171e48;
}
.is-semibold-18-600-22 {
  font-family: Barlow-SemiBold;
  font-size: 18px;
  font-weight: 600;
  line-height: 22px;
  color: #171e48;
}
.is-regular-16-000-42 {
  font-family: Barlow-Regular !important;
  font-size: 16px;
  font-weight: normal;
  line-height: 42px !important;
}
.is-regular-16-000-00 {
  font-family: Barlow-Regular !important;
  font-size: 16px;
  font-weight: normal;
  line-height: normal !important;
}
.is-medium-14-500-42 {
  font-family: Barlow-Medium;
  font-size: 14px;
  font-weight: 500;
  line-height: 42px !important;
}
.is-semiBold-14-500-42 {
  font-family: Barlow-SemiBold !important;
  font-size: 14px;
  font-weight: 500;
  line-height: 42px !important;
}
.is-bold-16-000-106 {
  font-family: Barlow-Bold !important;
  font-size: 16px;
  font-weight: normal;
  line-height: 80px;
}
.is-semibold-16-000-106 {
  font-family: Barlow-SemiBold !important;
  font-size: 16px;
  font-weight: normal;
}

html,
body {
  overflow: hidden;
  font-family: "Barlow";
}
.heading-secondary {
  font-weight: 500;
  font-size: 13px;
  text-transform: uppercase;
}
.input:focus,
.input:active,
.input.is-active,
.select select:focus {
  border-color: #ccc;
  box-shadow: none;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(200px);
  opacity: 0.5;
}
.is-pointer {
  cursor: pointer;
}
.is-blue {
  color: #5c7ef7;
}
.light-weight {
  font-size: 15px;
  font-weight: 300;
}
.lighter-weight {
  font-size: 15px;
  font-weight: 200;
}
.medium-weight {
  font-weight: 500;
  font-size: 15px;
}
.custom-checkbox {
  position: relative;
  height: 20px;
  width: 20px;
  visibility: hidden;
  margin-right: 0.5rem;
  vertical-align: middle;
  cursor: pointer;
  z-index: 5;

  &::before {
    content: "";
    position: absolute;
    visibility: visible;

    width: 20px;
    height: 20px;
    z-index: 2;
    background-color: #fff;
    // border-radius: 1.5rem;
    border: 2px solid #5c7ef7;
  }

  &:hover::before {
    background-color: #fff;
  }

  &::after {
    border-width: 0px 0px 0px 0px;
    visibility: visible;
  }

  &:checked::before {
    background-color: #fff;
    border: 2px solid #5c7ef7;
    // border-radius: 1.5rem;
    overflow: hidden;
    visibility: visible;

    backface-visibility: none;
  }

  &:checked::after {
    position: absolute;
    content: "";
    z-index: 3;
    visibility: visible;

    left: 8px;
    top: 4px;
    width: 5px;
    height: 9px;
    border: solid #5c7ef7;
    border-width: 0px 2px 2px 0px;
    transform: rotate(45deg);
  }
  &.is-dot {
    &:checked::after {
      position: absolute;
      content: "";
      z-index: 3;
      visibility: visible;
      left: 6px;
      top: 6px;
      width: 6px;
      height: 5px;
      border: solid #5c7ef7;
      border-width: 4px;
      border-radius: 5px;
    }
  }
  &.is-rounded {
    &::before {
      content: "";
      visibility: visible;
      border-radius: 1.5rem;
    }
  }
}
.tooltip {
  font-family: Barlow-Medium;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: 0.06px;
  font-size: 13px;
  display: block !important;
  z-index: 10000;

  .tooltip-inner {
    background: #171e48;
    color: white;
    border-radius: 4px;
    padding: 4px 7px 8px;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: black;
    z-index: 1;
  }

  &[x-placement^="top"] {
    margin-bottom: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[aria-hidden="true"] {
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.15s, visibility 0.15s;
  }

  &[aria-hidden="false"] {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.15s;
  }
}
.is-mr-5 {
  margin-right: 5px;
}
.is-mr-15 {
  margin-right: 15px;
}
.is-mx-5 {
  margin-right: 5px;
  margin-left: 5px;
}
.is-align-items-center {
  align-items: center !important;
}
.has-slimscroll-xs {
  &::-webkit-scrollbar {
    width: 0.3rem !important;
    height: 0.3rem !important;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 1rem !important;
    background: rgba(0, 0, 0, 0.2) !important;
  }
}
</style>
